import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext, useRef, useCallback, useState } from 'react';
import classNames from 'classnames';
import Big from 'big.js';
import InputNumber from '../input-number';
import Icon from '../icon';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { tuple } from '../_utils/type';
import { omit } from '../_utils/omit';
import { useMergedState } from '../_utils/hooks';
export var StepTypes = tuple('embed', 'base');

var InternalStepper = function InternalStepper(props, ref) {
  var _useContext = useContext(ConfigContext),
      userDefaultProps = _useContext.compDefaultProps,
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var inputNumberProps = getCompProps('Stepper', userDefaultProps, props);
  var customPrefixcls = inputNumberProps.prefixCls,
      onChange = inputNumberProps.onChange,
      step = inputNumberProps.step,
      type = inputNumberProps.type,
      stepBtnClassName = inputNumberProps.stepBtnClassName,
      max = inputNumberProps.max,
      min = inputNumberProps.min,
      disabled = inputNumberProps.disabled,
      propsValue = inputNumberProps.value,
      defaultValue = inputNumberProps.defaultValue;
  var inputPrefixCls = getPrefixCls(prefixCls, 'inputNumber', customPrefixcls);
  devWarning(typeof step !== 'number', 'stepper', "step\u5FC5\u987B\u4E3A\u4E00\u4E2A\u6570\u503C");
  var thisInputNumberRef = useRef();
  var stepperrref = useRef();
  var inputNumberRef = ref || thisInputNumberRef;
  var stepMouseDownDelayTimer = useRef(null);
  var stepMouseDownIntervalTimer = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMinusdisabled = _useState2[0],
      setMinusdisabled = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPlusdisabled = _useState4[0],
      setPlusdisabled = _useState4[1];

  var _useMergedState = useMergedState(undefined, {
    value: propsValue,
    defaultValue: defaultValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1]; // class


  var getStepBtnClassNames = function getStepBtnClassNames(stepType, btnType) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7, _classNames;

    var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return classNames((_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(inputPrefixCls, "-")).call(_context, stepType, "Step"), true), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(inputPrefixCls, "-")).call(_context2, stepType, "Step-disabled"), isDisabled), _defineProperty(_classNames, _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(inputPrefixCls, "-")).call(_context4, stepType, "Step-")).call(_context3, btnType), btnType), _defineProperty(_classNames, _concatInstanceProperty(_context5 = "".concat(inputPrefixCls, "-")).call(_context5, stepType, "Step-small"), inputNumberProps.size === 'small'), _defineProperty(_classNames, _concatInstanceProperty(_context6 = "".concat(inputPrefixCls, "-")).call(_context6, stepType, "Step-middle"), inputNumberProps.size === 'middle'), _defineProperty(_classNames, _concatInstanceProperty(_context7 = "".concat(inputPrefixCls, "-")).call(_context7, stepType, "Step-large"), inputNumberProps.size === 'large'), _defineProperty(_classNames, stepBtnClassName, stepType === 'base' && stepBtnClassName), _classNames));
  };

  var getStepPrefix = function getStepPrefix() {
    if (type === 'embed') {
      return null;
    }

    var decreaseClassName = getStepBtnClassNames('base', 'decrease', showPlusdisabled || disabled);
    return /*#__PURE__*/React.createElement("span", {
      className: decreaseClassName,
      onMouseDown: function onMouseDown() {
        if (disabled) return;
        handleStepMouseDown('minus');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(inputPrefixCls, "-icon"),
      type: "reduce"
    }));
  };

  var getStepSuffix = function getStepSuffix() {
    var increaseClassName = getStepBtnClassNames('base', 'increase', showMinusdisabled || disabled);
    return type === 'embed' ? getEmbedStepView() : /*#__PURE__*/React.createElement("span", {
      className: increaseClassName,
      onMouseDown: function onMouseDown() {
        if (disabled) return;
        handleStepMouseDown('plus');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(inputPrefixCls, "-icon"),
      type: "add"
    }));
  };

  var handleStepChang = function handleStepChang(type) {
    var stepNum = parseFloat(step);

    if (typeof stepNum !== 'number') {
      return false;
    }

    var startingNumber = parseFloat(stepperrref.current.value) || parseFloat(inputNumberProps.min) || 0;
    var calculationResults = new Big(startingNumber)[type](stepNum).valueOf();
    var legalNumber = stepperrref.current.verifiValue(calculationResults);

    if (legalNumber === false) {
      return false;
    }

    if (typeof max === 'number') {
      if (Number(legalNumber) + step > max) {
        setMinusdisabled(true);
      } else {
        setMinusdisabled(false);
      }

      if (Number(legalNumber) > max) {
        return false;
      }
    }

    if (typeof min === 'number') {
      if (Number(legalNumber) - step < min) {
        setPlusdisabled(true);
      } else {
        setPlusdisabled(false);
      }

      if (Number(legalNumber) < min) {
        return false;
      }
    } // props?.value === undefined && stepperrref.current.setValue(legalNumber)


    (props === null || props === void 0 ? void 0 : props.value) === undefined && setValue(legalNumber);
    onChange && onChange({
      target: {
        value: legalNumber
      }
    });
  };

  var setpLongPress = function setpLongPress(type) {
    stepMouseDownIntervalTimer.current = setInterval(function () {
      handleStepChang(type);
    }, 300);
  };

  var handleStepMouseDown = function handleStepMouseDown(type) {
    handleStepChang(type);
    stepMouseDownDelayTimer.current = setTimeout(function () {
      setpLongPress(type);
    }, 300);
    document.addEventListener('mouseup', clearAllTimer, true);
    return false;
  };

  var handleChange = function handleChange(event) {
    var _a;

    var number = parseFloat(event.target.value);

    if (String(value).length && ((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.length) >= String(value).length && event.target.value !== '' && (props === null || props === void 0 ? void 0 : props.value) !== undefined && (max && max < number || min && min > number)) {
      return;
    }

    (props === null || props === void 0 ? void 0 : props.value) === undefined && setValue(event.target.value);
    (props === null || props === void 0 ? void 0 : props.value) === undefined && stepperrref.current.setValue(event.target.value);
    onChange && onChange(event);
  };

  var clearAllTimer = useCallback(function () {
    stepMouseDownDelayTimer.current && clearTimeout(stepMouseDownDelayTimer.current);
    stepMouseDownIntervalTimer.current && clearInterval(stepMouseDownIntervalTimer.current);
    document.removeEventListener('mouseup', clearAllTimer);
    return false;
  }, [stepMouseDownDelayTimer, stepMouseDownIntervalTimer]);

  var getEmbedStepView = function getEmbedStepView() {
    var _classNames2, _classNames3;

    var embedStepClassName = getStepBtnClassNames('embed');
    var plusClassName = classNames("".concat(inputPrefixCls, "-embedStep-plus"), (_classNames2 = {}, _defineProperty(_classNames2, stepBtnClassName, stepBtnClassName), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-embedStep-disabled"), showMinusdisabled || disabled), _classNames2));
    var minusClassName = classNames("".concat(inputPrefixCls, "-embedStep-minus"), (_classNames3 = {}, _defineProperty(_classNames3, stepBtnClassName, stepBtnClassName), _defineProperty(_classNames3, "".concat(inputPrefixCls, "-embedStep-disabled"), showPlusdisabled || disabled), _classNames3));
    return /*#__PURE__*/React.createElement("span", {
      className: embedStepClassName
    }, /*#__PURE__*/React.createElement("span", {
      className: plusClassName,
      onMouseDown: function onMouseDown() {
        if (disabled) return;
        handleStepMouseDown('plus');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(inputPrefixCls, "-icon"),
      type: "arrow-up"
    })), /*#__PURE__*/React.createElement("span", {
      className: minusClassName,
      onMouseDown: function onMouseDown() {
        if (disabled) return;
        handleStepMouseDown('minus');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(inputPrefixCls, "-icon"),
      type: "arrow-down"
    })));
  };

  return /*#__PURE__*/React.createElement(InputNumber, _extends({}, omit(inputNumberProps, ['step', 'type', 'stepBtnClassName', 'value', 'defaultValue']), {
    ref: inputNumberRef,
    className: "".concat(inputPrefixCls, "-stepper"),
    stepperrref: stepperrref,
    value: value,
    prefix: getStepPrefix(),
    suffix: getStepSuffix(),
    onChange: handleChange
  }));
};

var Stepper = /*#__PURE__*/React.forwardRef(InternalStepper);
Stepper.displayName = 'Stepper';
export default Stepper;